"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const uuid = __importStar(require("uuid"));
const short_hash_1 = __importDefault(require("short-hash"));
const types_1 = require("../types");
const nodeSummary_1 = require("../helper/nodeSummary");
// Please leave it as it, import from .. is causing cyclic dependency
const NodesConfig_1 = require("../config/NodesConfig");
const utils_1 = require("../helper/utils");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const defaultConditionalSetting = { conditions: [], expression: "" };
class BasicNode {
  constructor(props) {
    this.conditionalSettings = defaultConditionalSetting;
    this.getConditionalSetting = () => {
      return this.conditionalSettings;
    };
    //  todo change logic for expression if supporting multiple conditions.
    this.addConditionalSetting = condition => {
      let index = this.conditionalSettings.conditions.findIndex(
        x => x.id == condition.id
      );
      if (index >= 0) {
        this.conditionalSettings.conditions[index] = condition;
      } else {
        this.conditionalSettings.conditions.push(condition);
      }
      this.conditionalSettings.expression = `( (${condition.id}) )`;
    };
    //todo change logic for expression if supporting multiple conditions.
    this.removeConditionalSetting = id => {
      this.conditionalSettings.conditions = this.conditionalSettings.conditions.filter(
        x => x.id !== id
      );
      this.conditionalSettings.expression = "";
    };
    this.getSelectedResource = () => {
      return this.selectedResource || null;
    };
    this.setSelectedResource = selectedResource => {
      this.selectedResource = selectedResource;
    };
    this.removeNodeRef = selectedResource => {
      if (!selectedResource) return;
      if (
        selectedResource &&
        selectedResource.context &&
        selectedResource.context.selectedNode
      ) {
        selectedResource.context.selectedNode = this.removeNodeRef(
          selectedResource.context.selectedNode
        );
      }
      return Object.assign({}, selectedResource, {
        nodeRef: undefined
      });
    };
    this.getNodeName = () => {
      return this.name || "";
    };
    this.setNodeName = name => {
      this.name = name;
    };
    this.setId(props);
    this.setType(props);
    this.next = props.next;
    this.previous = props.previous;
    this.inputs = props.inputs;
    this.selectedResource = props.selectedResource;
    this.conditionalSettings =
      props.conditionalSettings ||
      JSON.parse(JSON.stringify(defaultConditionalSetting));
    this.target =
      props.type === types_1.NODE_TYPES.DELAY
        ? props.target
        : NodesConfig_1.getNodeConfig(this.type).target;
  }
  setDataResolver(dataResolver) {
    this.dataResolver = dataResolver;
  }
  getDataResolver() {
    return this.dataResolver || null;
  }
  setPrevious(id) {
    this.previous = id;
  }
  setNext(id) {
    this.next = id;
  }
  getNodeId() {
    return this.id;
  }
  getNodeType() {
    return this.type;
  }
  getCloudProvider() {
    return cloudProvider_1.default.UNKNOWN;
  }
  getNodeLabel() {
    return NodesConfig_1.getNodeConfig(this.type).label;
  }
  getNodeDescription() {
    return this.description || "";
    // return getNodeConfig(this.type).description;
  }
  setNodeDescription(description) {
    this.description = description;
  }
  getNodeData() {
    if (!this.inputs) return null;
    return this.inputs;
  }
  setTarget(target) {
    throw new Error("can not update target");
  }
  setNodeData(data) {
    //analytics
    // track(events.NODE_DATA_SAVED_SUCCESSFULLY, { nodeName: this.type });
    this.inputs = data;
  }
  getTarget() {
    return this.target;
  }
  async getSummary() {
    return (
      (await nodeSummary_1.getSummary(
        this.type,
        this.inputs,
        this.getDataResolver()
      )) || ""
    );
  }
  setType(props) {
    if (!props.type) {
      throw "Node type not defined.";
    }
    this.type = props.type;
  }
  getTa() {
    return NodesConfig_1.getNodeConfig(this.type).ta;
  }
  setBasicNodeId(props) {
    if (props.id) {
      this.id = props.id;
    } else {
      this.id = "node-" + short_hash_1.default(uuid.v4()) + "-" + props.type;
    }
  }
  getAttachedApisFromParent(selectedResource) {
    let apis = [];
    // get attached apis of its own selected resource
    let ownSelectedResource = this.getSelectedResource();
    if (ownSelectedResource && ownSelectedResource.nodeRef) {
      apis = apis.concat(
        ownSelectedResource.nodeRef.getAttachedApis(ownSelectedResource)
      );
    }
    if (selectedResource && selectedResource.path) {
      return apis.filter(x =>
        selectedResource.path.includes(utils_1.getPrettyName(x.method))
      );
    }
    return apis;
  }
  getAttachedApis(selectedResource) {
    return [];
  }
  async getAvailableResources() {
    return [];
  }
  async getOutputKeys(params) {
    return [];
  }
  getKeysForPath(path, keys) {
    path = path.replace("..", ".");
    return keys
      .filter(x => {
        return x.value.startsWith(path) || x.name.startsWith(path);
      })
      .map(x => {
        x.name = x.name.substring(x.name.indexOf(".") + 1);
        x.value = x.value.replace("..", ".").substring(path.length + 1);
        return x;
      });
  }
  getNext() {
    return this.next || null;
  }
  getPrevious() {
    return this.previous || null;
  }
  serializeNode() {
    let nodeData = this.getNodeData();
    let selectedResource = this.getSelectedResource();
    let selectedResourceWithOutRef =
      this.removeNodeRef(selectedResource) || null;
    return {
      id: this.getNodeId(),
      type: this.getNodeType(),
      next: this.getNext(),
      previous: this.getPrevious(),
      inputs: nodeData || {},
      target: this.getTarget(),
      selectedResource: selectedResourceWithOutRef,
      description: this.description,
      conditionalSettings: this.conditionalSettings,
      userDefinedNodeId: this.getUserDefinedNodeId()
    };
  }
  getUserDefinedNodeId() {
    return undefined;
  }
}
exports.BasicNode = BasicNode;
//# sourceMappingURL=BasicNode.js.map
